export default {
  data() {
      return {
        dados: null,
        pathApi: null
      }
    },
  methods: {
    _validate(){
      if (!this.pathApi){
        console.error( 'pathApi não está setado')
      }
    }
  }
}
